import { useNavigate } from 'react-router-dom'

import StrapiImage from '@app/components/Guide/ui/StrapiImage'

import {
  getReadMoreDescription,
  getReadMoreImage,
  getReadMoreMainTopicSlug,
  getReadMoreSlug,
  getReadMoreSubTabSlug,
  getReadMoreTitle,
} from './strapiBlocks.utils'
import { ReadMoreBlockType } from './types'

interface ReadMoreBlockProps {
  block: ReadMoreBlockType
}

export const ReadMoreBlock = ({ block }: ReadMoreBlockProps) => {
  const navigate = useNavigate()

  const title = getReadMoreTitle(block)
  const description = getReadMoreDescription(block)
  const slug = getReadMoreSlug(block)
  const subTabSlug = getReadMoreSubTabSlug(block)
  const mainTopicSlug = getReadMoreMainTopicSlug(block)
  const image = getReadMoreImage(block)

  if (!title || !slug) return null

  const href =
    mainTopicSlug && subTabSlug
      ? `/app/guide/${mainTopicSlug}/${subTabSlug}/${slug}`
      : `/app/guide/${slug}`

  return (
    <section className="pt-4">
      <div className="overflow-hidden transition-colors border rounded-xl border-border bg-card hover:bg-muted/30">
        <button
          type="button"
          className="flex w-full gap-4 p-4 text-left sm:p-5"
          onClick={() => navigate(href)}
        >
          {image && (
            <div className="hidden w-32 overflow-hidden rounded-lg shrink-0 bg-muted sm:block">
              <StrapiImage
                src={image}
                alt={title}
                className="object-cover w-full h-full aspect-[4/3]"
              />
            </div>
          )}

          <div className="flex flex-col min-w-0 gap-2">
            <p className="text-xs font-semibold tracking-[0.16em] uppercase text-primary">
              Read also
            </p>
            <h3 className="text-lg font-bold leading-snug text-foreground">{title}</h3>
            {description && (
              <p className="text-sm leading-6 text-muted-foreground line-clamp-2">{description}</p>
            )}
          </div>
        </button>
      </div>
    </section>
  )
}

export default ReadMoreBlock
